import React from 'react'

const TaskCount = ({ totalTaskCount, onClick }) => {
    return(
        <span className={`${totalTaskCount > 1 ? 'TaskCountSpan' : ''}`}
        onClick={() => {if (onClick) { onClick() }}}>{totalTaskCount > 1 ? "+" + (totalTaskCount-1) : ""}</span>
    )
}

export default React.memo(TaskCount)